import { useState } from "react";
import { useConfirm } from "features/home/ConfirmDialogProvider";
import { useIntl } from "react-intl";
import { Box } from "@mui/material";

export default function useDiscardConfirm() {
  const confirm = useConfirm();
  const { formatMessage } = useIntl();
  const [isConfirmed, setIsConfirmed] = useState(false);

  const handleDiscardConfirm = (onConfirm) => {
    confirm({
      title: formatMessage({ id: "popup.discard.title" }),
      content: (
        <Box sx={{ margin: "0 auto" }}>
          {formatMessage({ id: "popup.discard.description" })}
        </Box>
      ),
      confirmText: formatMessage({ id: "global.btn.discard" }),
      cancelText: formatMessage({ id: "global.btn.cancel" }),
    })
      .then(() => {
        setIsConfirmed(true);
        if (onConfirm) onConfirm();
      })
      .catch(() => {
        setIsConfirmed(false);
      });
  };

  const resetIsConfirmed = () => {
    setIsConfirmed(false);
  };

  return { handleDiscardConfirm, resetIsConfirmed, isConfirmed };
}
